import { Injectable } from '@angular/core';
import { User, UsersService } from '@compumark/analyst-selection-tool-client';
import { Observable } from 'rxjs';

@Injectable()
export class UserService {
  private user!: User;
  private userObservable!: Observable<User>;

  constructor(private users: UsersService) {
    this.userObservable = this.users.getCurrentUser();
    this.userObservable.subscribe((u) => {
      this.user = u;
    });
  }

  getCurrentUserObservable(): Observable<User> {
    return this.userObservable;
  }

  getCurrentUser(): User {
    return this.user;
  }
}
